






























import {Component, Vue} from 'vue-property-decorator';
import ViewBase from '@/views/ViewBase';
import MemberApi from '@/apis/MemberApi';
import MemberChangeBackupPasswordRequestModel from '@/models/member/MemberChangeBackupPasswordRequestModel';

@Component({
        name: 'MemberChangeBackupPassword',
    },
)
export default class MemberChangeBackupPassword extends ViewBase {

    public primaryPassword: string = '';
    public newBackupPassword1: string = '';
    public newBackupPassword2: string = '';
    public currentBackupPassword: string = '';

    public primaryPasswordRules(value: string): any {
        if ( value.trim().length === 0)
        {
            return 'Your primary password is required.';
        }

        return true;
    }

    public currentBackupPasswordRules(value: string): any {
        if ( value.trim().length === 0)
        {
            return 'Your current backup password is required.';
        }

        return true;
    }

    public newBackupPassword1Rules(value: string): any {
        if ( value.trim().length === 0)
        {
            return 'A new backup password is required.';
        }
        else if ( value.trim().length < 8)
        {
            return 'Minimum backup password length is 8 characters.';
        }
        else if ( value.trim() === this.currentBackupPassword)
        {
            return 'The new backup password may not be the same as your current backup password.';
        }
        else if ( value.trim() === this.primaryPassword)
        {
            return 'The new backup password may not be the same as your primary password.';
        }

        return true;
    }

    public newBackupPassword2Rules(value: string): any {
        if ( value.trim().length === 0)
        {
            return 'Please re-enter your new backup password.';
        }
        else if ( value.trim() !== this.newBackupPassword1)
        {
            return 'The re-entered new backup password is incorrect.';
        }

        return true;
    }

    public async saveClick() {

        if ( this.isFormValid() ) {
            try {
                this.resetProcessingValues();

                const request = new MemberChangeBackupPasswordRequestModel();
                request.primaryPassword = this.primaryPassword;
                request.currentBackupPassword = this.currentBackupPassword;
                request.newBackupPassword = this.newBackupPassword1;

                const api = new MemberApi();
                const response = await api.changeBackupPasswordAsync(this.$store.state.member.jwt, request);

                this.$store.commit('mutateSnackbarText', 'Your backup password has been changed.');
                this.$store.commit('mutateShowSnackbar', true);

                await this.$router.push({name: 'memberprofile'});

            }
            catch ( err ) {
                await this.handleProcessingErrorAsync(err);
            }
            finally {
                this.processing = false;
            }
        }
    }

    private isFormValid(): boolean {
        const form: any = this.$refs.changeBackupPasswordForm;

        return form.validate();
    }

}

